import Reveal from '@/components/base/Reveal';

export default function TestimonialsSection() {
  return (
    <section className="relative py-28 px-6 md:px-12 lg:px-16 bg-black">
      <div className="max-w-5xl mx-auto text-center">
        <Reveal variant="fadeUp" duration={900}>
          <div className="text-6xl text-white/55 font-serif leading-none mb-4">&ldquo;</div>
        </Reveal>

        <Reveal variant="fadeUp" delay={120} duration={1000}>
          <blockquote
            className="text-3xl md:text-4xl lg:text-5xl font-light text-white font-['Instrument_Serif'] leading-snug mb-10"
            style={{ letterSpacing: '-0.02em' }}
          >
            Sapphire Media Group is redefining youth appearances in software, in radio, in public &mdash; that’s what we do.
          </blockquote>
        </Reveal>

        <Reveal variant="fadeUp" delay={280} duration={800}>
          <div className="flex items-center justify-center gap-4">
            <div className="w-px h-6 bg-white/35" />
            <div>
              <span className="text-sm font-medium text-white">Julian van Doorn</span>
              <span className="text-sm text-white/55 ml-2">· Founder, Sapphire Media Group</span>
            </div>
            <div className="w-px h-6 bg-white/35" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
